import React from "react";

import { formatKST } from "../../utils/dateUtils";
import {
  deviceTypeBadgeClass,
  deviceTypeText,
  getBatteryText,
  getGpsText,
  getHeartRateText,
  getOwnerText,
  getSafeLastSeenForDisplay,
  getStreamStatusText,
} from "../../utils/deviceUtils";
import {
  statusBadgeClass,
  statusLabelText,
} from "../../utils/statusUtils";

export default function DeviceTable({ loading, devices }) {
  return (
    <div className="hidden overflow-hidden rounded-[22px] border border-gray-200 dark:border-white/10 lg:block">
      <div className="overflow-x-auto">
        <table className="min-w-[1250px] w-full border-collapse">
          <thead className="bg-gray-50 dark:bg-[#0F172A]">
            <tr className="text-left text-xs text-gray-500 dark:text-gray-400">
              <th className="px-4 py-4 font-semibold">장비명</th>
              <th className="px-4 py-4 font-semibold">종류</th>
              <th className="px-4 py-4 font-semibold">사용자/담당자</th>
              <th className="px-4 py-4 font-semibold">상태</th>
              <th className="px-4 py-4 font-semibold">마지막 통신시간</th>
              <th className="px-4 py-4 font-semibold">배터리</th>
              <th className="px-4 py-4 font-semibold">심박수</th>
              <th className="px-4 py-4 font-semibold">GPS</th>
              <th className="px-4 py-4 font-semibold">스트림 상태</th>
            </tr>
          </thead>

          <tbody>
            {!loading && devices.length === 0 ? (
              <tr>
                <td
                  colSpan={9}
                  className="px-4 py-12 text-center text-sm text-gray-500 dark:text-gray-400"
                >
                  표시할 장비가 없습니다.
                </td>
              </tr>
            ) : (
              devices.map((item) => {
                const rowStatus = String(item?.status || "").toUpperCase();

                const rowHighlight =
                  rowStatus === "ALERT"
                    ? "bg-red-50/70 dark:bg-red-500/5"
                    : rowStatus === "OFFLINE"
                    ? "bg-gray-50/80 dark:bg-white/[0.02]"
                    : rowStatus === "DISABLED"
                    ? "bg-slate-50/80 dark:bg-slate-500/[0.04]"
                    : "";

                return (
                  <tr
                    key={item.rowKey}
                    className={`border-t border-gray-100 text-sm dark:border-white/5 ${rowHighlight}`}
                  >
                    <td className="px-4 py-4">
                      <div className="font-semibold text-gray-900 dark:text-white">
                        {item.name || "-"}
                      </div>
                      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                        ID: {item.deviceId || "-"}
                      </div>
                    </td>

                    <td className="px-4 py-4">
                      <span
                        className={`inline-flex whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold ${deviceTypeBadgeClass(
                          item.deviceType
                        )}`}
                      >
                        {deviceTypeText(item.deviceType)}
                      </span>
                    </td>

                    <td className="px-4 py-4 text-gray-700 dark:text-gray-200">
                      {getOwnerText(item)}
                    </td>

                    <td className="px-4 py-4">
                      <span
                        className={`inline-flex whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold ${statusBadgeClass(
                          item.status
                        )}`}
                      >
                        {statusLabelText(item.status)}
                      </span>
                    </td>

                    <td className="whitespace-nowrap px-4 py-4 text-gray-600 dark:text-gray-300">
                      {formatKST(getSafeLastSeenForDisplay(item))}
                    </td>

                    <td className="px-4 py-4 text-gray-700 dark:text-gray-200">
                      {getBatteryText(item.battery, item.status)}
                    </td>

                    <td className="px-4 py-4 text-gray-700 dark:text-gray-200">
                      {getHeartRateText(item.heartRate, item.status)}
                    </td>

                    <td className="px-4 py-4 text-gray-500 dark:text-gray-400">
                      <div className="max-w-[220px] break-words">
                        {getGpsText(item)}
                      </div>
                    </td>

                    <td className="px-4 py-4 text-gray-700 dark:text-gray-200">
                      {getStreamStatusText(item)}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}